{
  describe: (name, body) -> do
    perform(@test.pushDescribe, name);
    body();
    perform(@test.popDescribe, null);
  end,
  skip: macro(expr) -> quote do perform(@test.pushSkip, null); $^{expr}; perform(@test.popSkip, null); end; end,
};
